import { OperationDef } from '../types';

/** Format binary data like `hexdump -C`: offset | hex bytes | ASCII */
export function formatHexDump(bytes: Uint8Array, bytesPerLine = 16): string {
  const lines: string[] = [];
  for (let offset = 0; offset < bytes.length; offset += bytesPerLine) {
    const chunk = bytes.slice(offset, offset + bytesPerLine);
    const hex = Array.from(chunk)
      .map(b => b.toString(16).padStart(2, '0'))
      .join(' ');
    const hexPadded = hex.padEnd(bytesPerLine * 3);
    const ascii = Array.from(chunk)
      .map(b => (b >= 0x20 && b <= 0x7e ? String.fromCharCode(b) : '.'))
      .join('');
    lines.push(`${offset.toString(16).padStart(8, '0')}  ${hexPadded} |${ascii}|`);
  }
  return lines.join('\n');
}

// Render components are attached in src/app/ui/component/StepRenderers.tsx
// and wired up via registry initialization.

export const showTextOp: OperationDef = {
  id: 'show-text',
  name: 'Show text',
  category: 'display',
  description: 'Näytä data tekstinä',
  process: async input => input,
};

export const hexDumpOp: OperationDef = {
  id: 'hex-dump',
  name: 'Hex dump',
  category: 'display',
  description: 'Näytä data hexdump -C -muodossa',
  defaultParams: { bytesPerLine: 16 },
  process: async input => input,
};

export const downloadOp: OperationDef = {
  id: 'download',
  name: 'Download',
  category: 'display',
  description: 'Lataa data tiedostona',
  process: async input => input,
};

export const statsOp: OperationDef = {
  id: 'stats',
  name: 'Statistics',
  category: 'display',
  description: 'Näytä rivien, sanojen ja merkkien määrä',
  process: async input => input,
};

export const showImageOp: OperationDef = {
  id: 'show-image',
  name: 'Show image',
  category: 'display',
  process: async input => input,
};

export const showSvgOp: OperationDef = {
  id: 'show-svg',
  name: 'Show SVG',
  category: 'display',
  process: async input => input,
};

export const displayOperations: OperationDef[] = [
  showTextOp,
  hexDumpOp,
  showImageOp,
  showSvgOp,
  downloadOp,
  statsOp,
];
